import type { IServerTableConfigResponse, ParseBetLimitsType, PayoutType, TableConfigType } from './types';

const chipColorCodesNormalizer = (colorCodes: string | string[] | undefined): string[] => {
  if (typeof colorCodes === 'string') {
    return colorCodes.split(',');
  }

  return Array.isArray(colorCodes) ? colorCodes : [];
};

const parsePayouts = (betCode: IServerTableConfigResponse['betCode']): PayoutType[] => {
  if (!betCode) {
    return [];
  } else {
    const bets = Object.keys(betCode);
    const payouts: PayoutType[] = [];
    bets.forEach((bet) => {
      if (betCode[bet] !== undefined) {
        payouts.push({
          code: parseInt(bet),
          payout: Number(betCode[bet]),
        });
      }
    });
    return payouts;
  }
};

export const mainTableConfigParser = ({
  resResult,
  parseBetLimits,
}: {
  resResult: IServerTableConfigResponse;
  parseBetLimits: ParseBetLimitsType;
}): TableConfigType => {
  if (
    !resResult.params ||
    !resResult.betCode ||
    !resResult.operatorGameId ||
    !resResult.tableId ||
    !resResult.tableName
  ) {
    throw new Error('Table config does not have required data');
  }
  try {
    return {
      aamsSessionId: resResult.params.aamsSessionId,
      aamsTicket: resResult.params.aamsTicket,
      betCode: resResult.betCode,
      betLimits: parseBetLimits(resResult.params),
      bettingTime: resResult.params.betting_time,
      chipAmounts: resResult.params.chip_amounts
        ? resResult.params.chip_amounts.split(',').map((el: string) => Number.parseFloat(el))
        : [],
      chipColorCodes: chipColorCodesNormalizer(resResult.params.chip_color_codes),
      dedicatedLanguage: resResult.params.dedicatedLanguage,
      defaultChipOrder: resResult.params.default_chip_order,
      enableVideoStats: resResult.params.enable_video_stats,
      gameStatsAddress: resResult.params.gamestats_address,
      gameTypeId: resResult.params.gametype_id,
      gsAddress: resResult.params.gs_address,
      hlsLocation: resResult.params.hls_location,
      hideLobby: resResult.params.hide_lobby,
      idleLimit: resResult.params.idle_limit_games,
      isPrizeDropBetDataSendEnabled: resResult.params.isPrizeDropBetDataSendEnabled,
      isPromoBetDataSendEnabled: resResult.params.isPromoBetDataSendEnabled,
      openHours: resResult.params.open_hours,
      openTime: resResult.params.openTime,
      operatorGameId: resResult.operatorGameId,
      operatorTheme: resResult.params.operator_theme,
      payoutBetMaxLimit: resResult.params.payout_bet_max_limit,
      payouts: parsePayouts(resResult.betCode),
      retrieveVideoQuality: resResult.params.retrive_video_quality,
      sessionLaunchTimePerTable: resResult.params.session_launch_time_per_table,
      storeVideoQuality: resResult.params.store_video_quality,
      subtitlesAvailable: resResult.params.subtitles_available === true,
      tableBetLimit: {
        max: resResult.params.table_bet_max_limit,
        min: resResult.params.table_bet_min_limit,
      },
      tableClosed: resResult.params.table_closed === undefined ? true : resResult.params.table_closed,
      tableName: resResult.tableName,
      tableType: resResult.params.table_type,
      videoLocation: resResult.params.video_location,
      videoPlayerVersion: resResult.params.video_player_version,
      wsAddress: resResult.params.ws_address,
      broadcasterWsAddress: resResult.params.broadcaster_ws + '/broadcast',
      broadcasterEnabled: resResult.params.broadcaster_enabled,
      chatVisibleByDefault: resResult.params.chatVisibleByDefault,
      isInfiniteAutoPlayEnabled: resResult.params.isInfiniteAutoPlayEnabled,
      maxMultiplier:resResult.params.max_multiplier,
    };
  } catch {
    throw new Error('Something is missing in table config');
  }
};
